import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const api = {
  // Auth
  login: (email, password) => axios.post(`${API}/auth/login`, { email, password }),
  register: (email, password) => axios.post(`${API}/auth/register`, { email, password }),

  // Properties
  getProperties: (params) => axios.get(`${API}/properties`, { params }),
  getProperty: (propertyId) => axios.get(`${API}/properties/${propertyId}`),

  // User actions
  getSavedProperties: (headers) => axios.get(`${API}/user/saved-properties`, { headers }),
  saveProperty: (propertyId, headers) => axios.post(`${API}/user/saved-properties/${propertyId}`, {}, { headers }),
  removeSavedProperty: (propertyId, headers) => axios.delete(`${API}/user/saved-properties/${propertyId}`, { headers }),

  getSavedSearches: (headers) => axios.get(`${API}/user/saved-searches`, { headers }),
  createSavedSearch: (data, headers) => axios.post(`${API}/user/saved-searches`, data, { headers }),
  deleteSavedSearch: (searchId, headers) => axios.delete(`${API}/user/saved-searches/${searchId}`, { headers }),

  getAlertSubscriptions: (headers) => axios.get(`${API}/user/alert-subscriptions`, { headers }),
  createAlertSubscription: (data, headers) => axios.post(`${API}/user/alert-subscriptions`, data, { headers }),
  toggleAlertSubscription: (subscriptionId, active, headers) => axios.patch(`${API}/user/alert-subscriptions/${subscriptionId}?active=${active}`, {}, { headers }),
  deleteAlertSubscription: (subscriptionId, headers) => axios.delete(`${API}/user/alert-subscriptions/${subscriptionId}`, { headers }),

  // Calendar
  getAuctionCalendar: () => axios.get(`${API}/auctions/calendar`),
  getAuctionHouses: () => axios.get(`${API}/auctions/houses`),

  // Admin
  getAllUsers: (headers) => axios.get(`${API}/admin/users`, { headers }),
  getAllPropertiesAdmin: (params, headers) => axios.get(`${API}/admin/properties`, { params, headers }),
  deleteProperty: (propertyId, headers) => axios.delete(`${API}/admin/properties/${propertyId}`, { headers }),
  getAllSubscriptions: (headers) => axios.get(`${API}/admin/subscriptions`, { headers }),
  triggerManualScrape: (headers) => axios.post(`${API}/admin/scrape`, {}, { headers }),
  getAdminStatistics: (headers) => axios.get(`${API}/admin/statistics`, { headers }),
};
